import script from "./status-badge.vue?vue&type=script&lang=tsx"
export * from "./status-badge.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__